var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['error-state error-state--' + _vm.color]},[_c('img',{staticClass:"error-state__image",attrs:{"src":require('../../assets/svg-icons/compass.svg'),"alt":"","aria-hidden":"true"}}),_vm._v(" "),_vm._t("default",function(){return [_c('p',{staticClass:"error-state__message"},[_vm._v(_vm._s(_vm.message))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }